import { render, staticRenderFns } from "./cascader.vue?vue&type=template&id=210fb09e&scoped=true&"
import script from "./cascader.vue?vue&type=script&lang=js&"
export * from "./cascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210fb09e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('210fb09e')) {
      api.createRecord('210fb09e', component.options)
    } else {
      api.reload('210fb09e', component.options)
    }
    module.hot.accept("./cascader.vue?vue&type=template&id=210fb09e&scoped=true&", function () {
      api.rerender('210fb09e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/cascader.vue"
export default component.exports